import { useEffect, useMemo, useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router";
import CustomAlert from "@core/components/dialog/CustomAlert";
import { useUiStore } from "@core/stores/uiStore";
import { useDialog } from "@core/components/dialog/hooks/useDialog";
import { useMessage } from "@core/hooks/useMessage";
import { getLoginUrl } from "@core/utils/urlUtil";

export default function LoginAlert() {
  const network = useUiStore((state) => state.network);
  const { isOpen, open, toggle } = useDialog({ type: "alert", name: "loginAlert" });
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const loginType = useMemo(() => searchParams?.get("loginType"), [searchParams]);
  const t = useMessage();

  // 초기 마운트 발생 시에만 실행
  useEffect(() => {
    open();
  }, []);

  const loginAlertHandleClick = useCallback(() => {
    if (loginType === "plaync") {
      window.location.href = getLoginUrl(network, window.location.href);
      return;
    }

    return navigate("/", { replace: true });
  }, [navigate, network]);

  return (
    <CustomAlert name="loginAlert" isOpen={isOpen} onOpenChange={toggle} onClick={loginAlertHandleClick}>
      {t("COMMON.LOGIN")}
    </CustomAlert>
  );
}
